import {KeyValuePipe} from '@angular/common';
import {Component, forwardRef, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ColorSwatchKey} from '../preferences.service';

export const ColorSwatchMap = new Map<ColorSwatchKey, string>([
    [ColorSwatchKey.Black, '#000000'],
    [ColorSwatchKey.White, '#ffffff'],
    [ColorSwatchKey.Grey, '#9e9e9e'],
    [ColorSwatchKey.DarkGrey, '#212121'],
]);

@Component({
    selector: 'frog-swatch-picker',
    templateUrl: './swatch-picker.component.html',
    styleUrls: ['./swatch-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SwatchPickerComponent),
            multi: true,
        },
    ],
    imports: [KeyValuePipe],
})
export class SwatchPickerComponent implements OnInit, ControlValueAccessor {
    public readonly swatches = ColorSwatchMap;
    public onChange: any = () => {};

    private _value: ColorSwatchKey;

    constructor() {}

    get value(): ColorSwatchKey {
        return this._value;
    }

    set value(val: ColorSwatchKey) {
        if (val !== undefined && this._value !== val) {
            this._value = val;
            this.onChange(val);
        }
    }

    ngOnInit(): void {}

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {}

    writeValue(value: ColorSwatchKey): void {
        this.value = value;
    }
}
